<template>
  <v-app>
    <v-container>
      <configuration-firstscreen
        v-if="showFirstScreen"
        :configuration-type="configuration.type"
        :planogramms="configuration.planogramm"
        :screen="configuration.interface_description.first_screen"
        :nomenclatures="nomenclatures"
        @data="onStartToPay"
        @screen="onShowSecondScreen"
      />
      <!--      SecondScreen-->
      <configuration-second-screen
        v-if="showSecondScreen"
        :configuration-type="configuration.type"
        :item="itemForSecondScreen"
        :planogramms="configuration.planogramm"
        :screen="configuration.interface_description.first_screen"
        @cancel="onShowFirstScreen"
        @data="onStartToPay"
      />
      <!-- ErrorScreen -->
      <configuration-error-screen
        v-if="showErrorScreen"
        :screen="configuration.interface_description.error_screen"
      />
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
      <v-row>
        <v-col>
          <v-footer id="footerId">
            <v-container>
              <v-row no-gutters>
                <v-col
                    class="text-center my-0 py-0"
                    cols="12"
                    sm="2"
                    style="cursor: pointer;"
                    @click="onOpenPointStuff('termsOfService.offers')"
                >
                  Оферта
                </v-col>
                <v-col
                    class="text-center my-0 py-0"
                    cols="12"
                    sm="4"
                    style="cursor: pointer;"
                    @click="onOpenPointStuff('termsOfService.methods')"
                >
                  Способы оплаты и возврата
                </v-col>
                <v-col
                    class="text-center my-0 py-0"
                    cols="6"
                    sm="3"
                    style="cursor: pointer;"
                    @click="onOpenPointStuff('termsOfService.help')"
                >
                  Помощь
                </v-col>
                <v-col
                    class="text-center my-0 py-0"
                    cols="6"
                    sm="3"
                    style="cursor: pointer;"
                    @click="onOpenPointStuff('termsOfService.contacts')"
                >
                  Контакты
                </v-col>
              </v-row>
              <v-row
                  no-gutters
                  class="d-flex justify-center py-4"
              >
                <v-col
                    cols="4"
                    class="d-flex justify-center"
                >
                  <v-img
                      contain
                      max-height="50"
                      max-width="150"
                      :src="`data:image/jpg;base64,${this.qrLogo}`"
                  />
                </v-col>
              </v-row>
              <v-row
                  no-gutters
                  class="footer-text"
              >
                <v-col
                    class="text-center my-0 py-0"
                    cols="12"
                >
                  {{ client.name.short }}
                </v-col>
                <v-col
                    class="text-center my-0 py-0"
                    cols="12"
                >
                  ИНН:  {{ client.inn }}
                </v-col>
                <v-col
                    class="text-center my-0 py-0"
                    cols="12"
                >
                  ОГРН:  {{ client.ogrn }}
                </v-col>
              </v-row>
            </v-container>
          </v-footer>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import { guid, setScreenBackground, setScreenBackgroundById } from "@/views/loyalty/shared/modules/utilities"
import { configuration, ConfigurationTypeEnum } from "@/views/loyalty/models/justpay-configuration.model"
import ConfigurationFirstscreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationFirstscreen.vue"
import ConfigurationSecondScreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationSecondScreen.vue"
import ConfigurationErrorScreen from "@/views/loyalty/shared/components/justpay-configuration/ConfigurationErrorScreen.vue"
import { JustpayPaymentMqttService } from "@/views/loyalty/shared/services/justpay-paymentmqtt-service"
import { JustpayMediaFileService } from "@/views/loyalty/shared/services/justpay-mediafile-service"

export default {
  components: { ConfigurationErrorScreen, ConfigurationSecondScreen, ConfigurationFirstscreen },
  data: () => ({
    amountForPay: 0,
    anyAmount: "0",
    client: { name: { short: '' } },
    configuration: configuration,
    justpayMediaFileService: null,
    // errorScreen: false,
    // firstScreen: true,
    guid: null,
    itemForSecondScreen: {},
    nomenclatures: [],
    overlay: false,
    paymentService: null,
    planogramm: {},
    pointId: '',
    priceOfGoods: 0,
    qrLogo: null,
    qrLogoId: null,
    secondScreen: false,
    showErrorScreen: false,
    showFirstScreen: true,
    showSecondScreen: false,
    showFinalScreen: false,
  }),
  computed: {
    ConfigurationTypeEnum () {
      return ConfigurationTypeEnum
    }
  },
  watch: {
    showErrorScreen (newVal) {
      if (newVal) {
        setScreenBackground(this.configuration.interface_description.error_screen.background)
      }
    },
    showFirstScreen (newVal) {
      if (newVal) {
        setScreenBackgroundById('footerId', this.configuration.interface_description.first_screen.background)
        setScreenBackground(this.configuration.interface_description.first_screen.background)
      }
    },
    configuration (newVal) {
      if (newVal) {
        setScreenBackgroundById('footerId', this.configuration.interface_description.first_screen.background)
      }
    }
  },
  async beforeMount () {
    this.paymentService = new JustpayPaymentSystemService()
    this.justpayMediaFileService = new JustpayMediaFileService()
    this.pointId = this.$route.query.id
    localStorage.setItem('pointId', this.pointId)
    console.log('pointId', this.pointId)
    const response = await this.paymentService.getEntities(this.pointId)
    console.log('response', response)
    if (!response.value.error) {
      console.log('Success!')
      this.client = response.value.data.client
      this.configuration = response.value.data.configuration
      this.nomenclatures = response.value.data.nomenclatures
      this.qrLogoId = response.value.data.point.pointMedia.qrLogoId
      if (this.qrLogoId) {
        this.qrLogo = await this.justpayMediaFileService.getPictureFile(this.qrLogoId)
      }
    }
  },
async mounted () {
  this.guid = guid()
},
methods: {
  onOpenPointStuff (varPointStuff) {
    window.open(`pointStuff?id=${this.pointId}&var=${varPointStuff}`, '_blank')
  },
  onShowFirstScreen () {
    this.showFirstScreen = this.showScreen()
  },
  onShowSecondScreen (item) {
    console.log('onShowSecondScreen item', item)
    this.itemForSecondScreen = item
    this.showSecondScreen = this.showScreen()
  },
  showOnTheButton (planogramm) {
    let itemToShow = 0
    if (this.configuration.type === ConfigurationTypeEnum.Donation) {
      itemToShow = planogramm.price_cashless
    }
    if (this.configuration.type === ConfigurationTypeEnum.Vitrina || this.configuration.type === ConfigurationTypeEnum.Rele) {
      itemToShow = planogramm.amount
    }
    return itemToShow
  },
  onReloadWindow () {
    window.location.reload()
  },
  async onStartToPay (items, /* nomenclatureId */) {
    this.overlay = true
    const response = await this.paymentService.createPayment({ idempotency: this.guid, /* nomenclatureId: nomenclatureId, */ pointId: this.pointId, items: items, sum: items[0].amount, resultPage: 2 }) // resultPage = 2 (ResultPageEnum.QrWithoutOrderPay)
    this.overlay = false
    console.log('response for nspk', response)
    if (response.value.error) {
      this.firstScreen = false
      this.secondScreen = false
      this.errorScreen = true
      console.log('error', response.value.error)
    } else {
      this.firstScreen = true
      this.secondScreen = false
      const nspkLink = response.value.data.qr
      // window.open(nspkLink, '_blank')
      window.open(nspkLink, '_self')
    }
  },
  showScreen () {
    this.showErrorScreen = false
    this.showFirstScreen = false
    this.showSecondScreen = false
    return true
  },

}
}
</script>

<style scoped>
.test {
  font-size: 10px;
}
.footer-text {
  font-size: 8px;
}
</style>
